var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticStyle:{"font-weight":"400","margin":"0px !important","padding":"0px !important"}},[_vm._v("\n    "+_vm._s(_vm.currencyFormatter(_vm.VALUE, _vm.params.data.doviz == "USD"
                      ? "$"
                      : _vm.item.doviz == "EUR"
                      ? "€"
                      : "₺"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }